import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const FallbackWrapper = styled.div<{ fullScreen?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: ${({ fullScreen }) => (fullScreen ? '100dvh' : '100%')};
  justify-content: center;
  min-height: 320px;
  padding: 24px;
  text-align: center;
  width: 100%;
`

export const FallbackTitle = styled.div`
  color: ${colors.gray850};
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
`

export const FallbackText = styled.div`
  color: ${colors.gray400};
  font-size: 16px;
  margin-bottom: 24px;
  max-width: 480px;
`
